var SchedulesOnProfileController = /** @class */ (function () {
    /*@ngInject*/
    function SchedulesOnProfileController($rootScope, $scope, $timeout, $uibModal, jobService, jobMatchService, companyService, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    SchedulesOnProfileController.prototype.$onInit = function () {
        this.isLoading = true;
        this.scheduleActions = [
            "Create",
            "Modify",
            "Cancel"
        ];
        this.activeFeedbackTab = 2;
        this.scheduleAction = "Create";
        //variables
        this.tabs = [];
        this.validTabs = [];
        this.steps = [];
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this._initializeData(false);
        if (this.feedbackType == "PhoneScreen") {
            this.itemType = "phoneScreen";
        }
        else if (this.feedbackType == "Interview") {
            this.itemType = "interview";
        }
    };
    SchedulesOnProfileController.prototype._initializeData = function (isRefresh) {
        var _this = this;
        this.isLoading = true;
        this.getCandidateJobMatchCardInfo(function () {
            _this.getMoveToInterviewStepPossibility(function () {
                _this._checkAvailableFeedbackReports(function () {
                    _this._initFileNames();
                    _this._loadTabs(isRefresh);
                    _this.isLoading = false;
                });
            });
        });
    };
    SchedulesOnProfileController.prototype.getCandidateJobMatchCardInfo = function (successCallback) {
        var _this = this;
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, function (data) {
            _this.jobMatchInfo = data;
            _this.jobMatchInfo.interviewNextStep = false;
            _this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SchedulesOnProfileController.prototype.getMoveToInterviewStepPossibility = function (successCallback) {
        var _this = this;
        this.meetingService.getMoveToInterviewStepPossibility(this.scheduleId, function (data) {
            _this.jobMatchInfo.interviewNextStep = data.interviewNextStep;
            _this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = data.canMoveCandidateToInterviewAfterCurrentFeedback;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SchedulesOnProfileController.prototype._checkAvailableFeedbackReports = function (successCallback) {
        var _this = this;
        this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, function (data) {
            var feedbackReports = data.feedbackReportsAvailability;
            _this.isPhoneScreenFeedbackAvailable = feedbackReports["phoneScreenFeedbackReport"];
            _this.isInterviewFeedbackAvailable = feedbackReports["interviewFeedbackReport"];
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    SchedulesOnProfileController.prototype._initFileNames = function () {
        this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
        this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
        this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
    };
    SchedulesOnProfileController.prototype._loadTabs = function (isRefresh) {
        this.tabs = [];
        if (this.feedbackType == 'PhoneScreen') {
            this.tabs.push({ name: "Schedule", step: 'Phone Screen', fileName: "", url: "", isLoading: false });
            if (this.isPhoneScreenFeedbackAvailable) {
                this.phoneScreenFeedbackUrl = "api/jobmatch/getphonescreenfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                this.tabs.push({ name: "Completed Feedback", step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
            }
            this.tabs.push({ name: "Feedback", step: 'Phone Screen', fileName: "", url: "", isLoading: false, isActive: true });
            if (this.jobMatchInfo.interviewNextStep) {
                if (this.jobMatchInfo.availableActions.filter(function (action) { return action.action === 'Move to Interview'; }).length > 0) {
                    this.tabs.push({ name: "Move to Interview", step: 'Phone Screen', fileName: "", url: "", isLoading: false });
                    if (isRefresh) {
                        this.confirmMoveCandidateToInterview();
                    }
                }
                else if (this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback) {
                    //show can be moved after this feedback complete
                    this.tabs.push({ name: "Move to Interview", step: 'Phone Screen', fileName: "", url: "", isLoading: false, disabled: true, message: 'Move to Interview action is available only if you completed the current Phone Screen feedback.', disabled: true });
                }
                else {
                    //show complete all to move 
                    this.tabs.push({ name: "Move to Interview", step: 'Phone Screen', fileName: "", url: "", isLoading: false, disabled: true, message: 'Move to Interview action is available only if all the Phone Screen feedback(s) have been completed for this candidate.', disabled: true });
                }
            }
        }
        else if (this.feedbackType == 'Interview') {
            this.tabs.push({ name: "Schedule", step: 'Interview', fileName: "", url: "", isLoading: false });
            if (this.allowInterviewSchedule) {
                if (this.isInterviewFeedbackAvailable) {
                    this.interviewFeedbackUrl = "api/jobmatch/getinterviewfeedbackreport/" + this.jobMatchId + "?companyId=" + this.companyId;
                    this.tabs.push({ name: "Completed Feedback", step: "Interview", fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, isLoading: false });
                }
                this.tabs.push({ name: "Feedback", step: 'Interview', fileName: "", url: "", isLoading: false, isActive: true });
            }
            else {
                this.tabs[0].isActive = true;
            }
        }
        this._setActiveTab();
    };
    SchedulesOnProfileController.prototype._setActiveTab = function () {
        this.activeTab = this.tabs.findIndex(function (tab) { return tab.isActive == true; });
    };
    SchedulesOnProfileController.prototype.feedbackSaveCallback = function () {
        this._initializeData(true);
    };
    SchedulesOnProfileController.prototype.feedbackCompleteCallback = function () {
        if (this.completeFeedbackCallback) {
            this.completeFeedbackCallback();
        }
        this._initializeData(true);
    };
    SchedulesOnProfileController.prototype.confirmMoveCandidateToInterview = function () {
        var _this = this;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-info' style='margin-bottom: 0px;'><i class='fas fa-info-circle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: "Do you want to move the candidate to the Interview step?",
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this.moveCandidateToInterview();
                }
                else {
                    _this.tabs.forEach(function (tab) {
                        if (tab.name == 'Move to Interview') {
                            tab.isActive = true;
                        }
                        else {
                            tab.isActive = false;
                        }
                    });
                    _this._setActiveTab();
                }
            }
        });
    };
    SchedulesOnProfileController.prototype.moveCandidateToInterview = function () {
        var _this = this;
        var actionType = 'Move to Interview';
        var actionLabel = 'Move to Interview';
        var actionsModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-medium',
            component: 'schedulesOnProfileActionsModal',
            resolve: {
                actionType: function () {
                    return actionType;
                },
                actionLabel: function () {
                    return actionLabel;
                },
                jobMatchId: function () {
                    return _this.jobMatchInfo.jobMatchId;
                },
                candidateId: function () {
                    return _this.jobMatchInfo.id;
                },
                meetingScheduleId: function () {
                    return _this.scheduleId;
                },
                externalMeetingCallId: function () {
                    return _this.externalMeetingCallId;
                },
                sourceScreen: function () {
                    return _this.sourceScreen;
                },
                formalizeActivityPayload: function () {
                    return _this.formalizeActivityPayload;
                }
            }
        });
        actionsModal.result.then(function (callbackObject) {
            if (callbackObject.callbackType == 'moveCandidate') {
                _this.reloadAndMoveToInterviewCallback();
            }
        }, function (dismiss) {
        });
    };
    SchedulesOnProfileController.prototype.reloadAndMoveToInterviewCallback = function () {
        this._initializeData();
        if (this.moveToInterviewCallback) {
            this.moveToInterviewCallback();
        }
    };
    SchedulesOnProfileController.prototype.onScheduleCreated = function () {
        var label = this.itemType == "phoneScreen" ? 'Phone Screen' : 'Interview';
        this.alertsAndNotificationsService.showBannerMessage(label + " has been scheduled successfully.", "success");
    };
    SchedulesOnProfileController.prototype.onScheduleModified = function () {
        var label = this.itemType == "phoneScreen" ? 'Phone Screen' : 'Interview';
        this.alertsAndNotificationsService.showBannerMessage(label + " has been modified successfully.", "success");
    };
    SchedulesOnProfileController.prototype.onScheduleCancelled = function () {
        var label = this.itemType == "phoneScreen" ? 'Phone Screen' : 'Interview';
        this.alertsAndNotificationsService.showBannerMessage(label + " has been cancelled successfully.", "success");
    };
    return SchedulesOnProfileController;
}());
SchedulesOnProfileController.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', 'jobService', 'jobMatchService', 'companyService', 'meetingService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './schedules-on-profile.html;
import * as TEMPLATE from 'raw-loader!./schedules-on-profile.html';
export var SchedulesOnProfileComponent = {
    selector: 'schedulesOnProfile',
    component: {
        bindings: {
            jobMatchId: '@',
            candidateId: '@',
            saveCallback: '&',
            moveToInterviewCallback: '&',
            completeFeedbackCallback: '&',
            feedbackUserIdsList: '@',
            loginRequired: '<',
            externalCommentRequired: '<',
            feedbackType: '@',
            parentScheduleId: '@',
            scheduleId: '@',
            childScheduleId: '@',
            jobMatchObject: '=',
            jobLocation: '@',
            mode: '@',
            displayFeedback: '<',
            allowInterviewSchedule: '=',
            usersToEditFeedback: '=',
            feedbackReadOnly: '=',
            externalMeetingCallId: '=',
            sourceScreen: '@',
            formalizeActivityPayload: '='
        },
        controller: SchedulesOnProfileController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/schedulesOnProfile/schedules-on-profile.html'
    }
};
//# sourceMappingURL=schedules-on-profile.component.js.map